// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".track-tag .selected[data-v-4a07a171]{background-color:#e6f7f6!important;border-color:#e6f7f6!important;color:#666!important}.track-tag .el-tag[data-v-4a07a171]{background-color:#f0f0f0;border-color:#f0f0f0;color:#999;margin:0 10px 10px 0}.track-tag .button-new-tag[data-v-4a07a171]{margin-left:10px;height:32px;line-height:30px;padding-top:0;padding-bottom:0}.track-tag .input-new-tag[data-v-4a07a171]{width:90px;margin-left:10px;vertical-align:bottom}", ""]);
// Exports
module.exports = exports;
